import React from 'react'
import classnames from 'classnames'

import PreviewTextFieldSkeleton from '../PreviewTextFieldSkeleton'

import useStyles from './styles'

function SkeletonHeadlineText({ className, count, isInProgress, showLoadingAnimation }) {
  const classes = useStyles()

  return (
    <PreviewTextFieldSkeleton
      isInProgress={isInProgress}
      count={count}
      className={classnames(classes.skeletonHeadline, className)}
      showLoadingAnimation={showLoadingAnimation}
    />
  )
}

export default SkeletonHeadlineText
